import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import messages from './messages';
import { Fact, Subheading, Wrapper } from './styles';

const WelcomeTooltip = () => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<Subheading>{formatMessage(messages.subheading)}</Subheading>
			<Fact>
				{formatMessage(messages.mentalHealthFact, {
					bold: (chunks: ReactNode) => <strong>{chunks}</strong>,
				})}
			</Fact>
		</Wrapper>
	);
};

export default WelcomeTooltip;
